<script setup>
import HomeFeaturedAssignments from "@/components/layout3/home/featured/HomeFeaturedAssignments.vue";
import HomeRightSection from "@/components/layout3/home/HomeRightSection.vue";
import HomeTabs from "@/components/layout3/home/HomeTabs.vue";
import HomeBanner from "@/components/new-home-kain/HomeBanner.vue";
import LoadingHomeGridCourses from "@/components/utilities/loading/LoadingHomeGridCourses.vue";
import { useLayout2HomeTabsStore } from "@/modules/Layout2/stores/useLayout2HomeTabs.store";
import { useAllAvailableCourseStore } from "@/stores/useAllAvailableCourse.store";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";
import { computed, defineAsyncComponent } from "vue";

const EnrolledCourses = defineAsyncComponent({
  loader: () =>
    import("@/components/new-home/main-display/EnrolledCourses.vue"),
  suspensible: false,
  loadingComponent: LoadingHomeGridCourses,
  delay: 300,
});
// const FeaturedContent = defineAsyncComponent({
//   loader: () => import("@/components/new-home/main-display/FeaturedContent.vue"),
//   suspensible: false,
//   loadingComponent: LoadingHomeGridCourses,
//   delay: 300,
// });
const LearningPath = defineAsyncComponent({
  loader: () => import("@/components/new-home/main-display/LearningPath.vue"),
  suspensible: false,
  loadingComponent: LoadingHomeGridCourses,
  delay: 300,
});
const AvailableContent = defineAsyncComponent({
  loader: () =>
    import("@/components/new-home/main-display/AvailableContent.vue"),
  suspensible: false,
  loadingComponent: LoadingHomeGridCourses,
  delay: 300,
});

const allAvailableCourseStore = useAllAvailableCourseStore();
const homeMainTabsStore = useLayout2HomeTabsStore();
const { selectedMainTab } = storeToRefs(homeMainTabsStore);

const display = computed(() => {
  if (selectedMainTab.value === "enrolled") {
    return EnrolledCourses;
  }
  if (selectedMainTab.value === "playlist") {
    return LearningPath;
  }
  if (selectedMainTab.value === "content") {
    return AvailableContent;
  }
  return HomeFeaturedAssignments;
});

onMounted(() => {
  allAvailableCourseStore.handleFetchCategoriesWithCourses();
});
</script>
<template>
  <div class="flex-1">
    <div class="h-full w-full flex flex-row divide-x divide-brand/10">
      <div class="flex-1 flex flex-col gap-2 lg:gap-3">
        <HomeBanner />
        <div class="px-2">
          <HomeTabs :show-featured-tab="true" />
          <div class="w-full">
            <KeepAlive>
              <component :is="display" />
            </KeepAlive>
          </div>
        </div>
      </div>
      <div
        class="min-w-96 xl:w-1/4 p-2 hidden xl:block sticky top-20"
      >
        <HomeRightSection />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
